import {useEffect, useRef} from 'react';

import type {MouseEventHandler} from 'react';

import type {DropdownProps} from './types';

export const useDropdown = ({onChange, isOpen, setIsOpen}: DropdownProps) => {
  const isTooltipOpen = isOpen ? false : undefined;
  const ref = useRef(null);

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  const onClickContainer: MouseEventHandler = e => {
    e.stopPropagation();
  };

  const onClickItem: DropdownProps['onChange'] = newItem => {
    setIsOpen(false);
    onChange(newItem);
  };

  useEffect(() => {
    const listner = () => setIsOpen(false);

    document.addEventListener('click', listner);

    return () => document.removeEventListener('click', listner);
  }, [setIsOpen]);

  return {ref, isTooltipOpen, onToggle, onClickContainer, onClickItem};
};
